import axios from 'axios'
import router from '@/router'
import store from '@/store'

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  timeout: 60000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 从store获取token
    const token = store.getters['user/token']
    if (token) {
      // 添加token到请求头
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果状态码不是1，说明请求出错
    if (res.status !== 1) {
      // token过期或无效
      if (res.status === 401) {
        store.dispatch('user/logout')
        router.push('/login')
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    console.error('Response error:', error)
    return Promise.reject(error)
  }
)

export default request 